module.exports = __webpack_public_path__ + "img/facebook2.f8ab6597.png";